import React from 'react';

const VARIANTS = {
    default:   'bg-gray-100 dark:bg-white/[0.06] text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-white/[0.10] border border-transparent',
    primary:   'bg-cyan-500 text-white hover:bg-cyan-600 border border-transparent',
    danger:    'bg-red-500 text-white hover:bg-red-600 border border-transparent',
    view:      'bg-indigo-500/10 text-indigo-600 dark:text-indigo-400 border border-indigo-500/20 hover:bg-indigo-500/20',
    publish:   'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border border-emerald-500/20 hover:bg-emerald-500/20',
    draft:     'bg-amber-500/10 text-amber-700 dark:text-amber-400 border border-amber-500/20 hover:bg-amber-500/20',
    add:       'bg-cyan-500/10 text-cyan-700 dark:text-cyan-400 border border-cyan-500/20 hover:bg-cyan-500/20',
    edit:      'bg-purple-500/10 text-purple-600 dark:text-purple-400 border border-purple-500/20 hover:bg-purple-500/20',
};

const SIZES = {
    sm: 'px-2.5 py-1.5 text-xs',
    md: 'px-3.5 py-2 text-sm',
};

export default function ActionBtn({ onClick, children, variant = 'default', size = 'sm', type = 'button', icon, disabled, className = '' }) {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`inline-flex items-center gap-1.5 rounded-lg font-semibold transition-colors disabled:opacity-40 disabled:cursor-default whitespace-nowrap ${SIZES[size]} ${VARIANTS[variant] ?? VARIANTS.default} ${className}`}
        >
            {icon && <span className="shrink-0">{icon}</span>}
            {children}
        </button>
    );
}
